import * as jsxRuntime from "E:\\work\\projects\\fj-packages\\apps\\fj-login\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment